import { createAction, props } from '@ngrx/store';
import { ICentro, ICreateCentro, IDeleteCentroResponse, IUpdateCentro, IUpdateCentroResponse } from '../../interfaces/centros.interface';

export const GetCentros = createAction(
    '[Centros] Get Centros',
  );

export const GetCentrosSuccess = createAction(
    '[Centros] Get Centros Success',
    props<{centros: ICentro[]}>()
  );

export const CreateCentro = createAction(
    '[Centros] Create Centro',
    props<{centro: ICreateCentro}>()
  );

export const CreateCentroSuccess = createAction(
    '[Centros] Create Centro Success',
    props<{centro: ICentro}>()
  );

export const DeleteCentro = createAction(
    '[Centros] Delete Centro',
    props<{id: string}>()
  );

export const DeleteCentroSuccess = createAction(
    '[Centros] Delete Centro Success',
    props<{centro: IDeleteCentroResponse}>()
  );

export const UpdateCentro = createAction(
    '[Centros] Update Centro',
    props<{id: string, centro: IUpdateCentro }>()
  );

export const UpdateCentroSuccess = createAction(
    '[Centros] Update Centro Success',
    props<{centro: IUpdateCentroResponse }>()
  );
